<template>
  <div class="pr-input-number">
    <div class="pr-input-number__content">
      <div class="pr-input-number-box">
        <input
          class="pr-input-number-box__native"
          :class="{
            'pr-input-number-box__native--disabled': disabled,
          }"
          autocomplete="off"
          :name="name"
          v-bind="$attrs"
          :disabled="disabled"
          :value="inputValue"
          @input="handleChange"
          @blur="handleBlur"
        />

        <div class="add-minus">
          <img class="add-minus__icon" src="@/assets/icon/icon_arrow_up_brown.svg" @click="plusNumber" />
          <img
            class="add-minus__icon add-minus__icon--down"
            src="@/assets/icon/icon_arrow_down_brown.svg"
            @click="minusNumber"
          />
        </div>
      </div>
    </div>

    <p class="err-message" v-show="errorMessage">{{ errorMessage }}</p>
  </div>
</template>

<script>
import { defineComponent, watch } from 'vue';
import { useField } from 'vee-validate';

export default defineComponent({
  name: 'ReInputNumber',
  inject: {
    reFormItem: {
      default: '',
    },
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
    step: {
      type: [Number, String],
      default: 1,
    },
  },
  emits: ['update:value', 'update:modelValue'],
  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    const handleInput = (e) => {
      emit('change', e.target.value);
    };

    const plusNumber = () => {
      const val = Number(inputValue.value) + Number(props.step);

      inputValue.value = val;
      emit('update:modelValue', val);
    };
    const minusNumber = () => {
      let val = Number(inputValue.value) - Number(props.step);

      if (val < 0) {
        val = 0;
      }

      inputValue.value = val;
      emit('update:modelValue', val);
    };

    watch(inputValue, () => {
      emit('update:modelValue', inputValue.value);
    });

    watch(() => props.modelValue, () => {
      inputValue.value = props.modelValue;
    });

    return {
      handleInput,
      handleChange,
      plusNumber,
      minusNumber,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '~@/styles/share/errorMessage.scss';
$input-size-els: '.pr-input-number__prepend, .pr-input-number__content, .pr-input-number__append';

.pr-input-number {
  height: 50px;

  &--disabled {
    #{$input-size-els} {
      cursor: not-allowed;
    }
  }

  &__content {
    height: 50px;
    @include flex();
    @include padding(8px 10px);
    width: 100%;
    border: 1px solid rgba($c-main, 0.2);
    border-radius: 10px;

    &__prefix {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex: none;
      margin-right: 10px;
    }

    &__suffix {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex: none;
      margin-left: 10px;
    }
  }

  &__append {
    box-sizing: border-box;
    padding: 0 10px;
    // @include cus-radius(0, 4px, 4px, 0);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: auto;
    border: 1px solid $c-main;
    cursor: pointer;
  }
}

.pr-input-number-box {
  @include flex();

  &__native {
    flex: 1;
    @include font-normal();
    width: 100%;
    background-color: transparent;
    border: 0 transparent;
    outline: 0 transparent;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
    }

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &--readonly {
      cursor: pointer;
    }

    &::placeholder {
      @include font-style(rgba($c-main, 0.5), 16, 400, 1.6px, 28px);
    }
  }
}

.add-minus {
  @include flex(flex-start, flex-start, column);

  &__icon {
    width: 14px;
    cursor: pointer;

    &--down {
      margin-top: 12px;
    }
  }
}
</style>
